<template>
    <div class="login-container">

        <el-form class="login-form" :model="form" ref="loginForm" :rules="loginRules">
            <div class="title-container">
                <h3 class="title">WRC Login</h3>
            </div>
            <el-form-item prop="username">
                <el-input
                        placeholder="Enter your email"
                        prefix-icon="el-icon-user-solid"
                        v-model="form.username">
                </el-input>
            </el-form-item>

            <el-form-item prop="password">
                <el-input
                        show-password
                        placeholder="Enter your password"
                        prefix-icon="el-icon-lock"
                        v-model="form.password"
                        @keyup.enter.native="doLogin">
                </el-input>
            </el-form-item>

            <el-button :loading="loggingIn" type="default" style="width:100%;margin-bottom:80px;" @click.native.prevent="doLogin">Login</el-button>
        </el-form>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
    name: 'login',
    data: function() {
        return {
            loginRules: {
                username: [
                    { required: true, message: "Please enter username", trigger: 'blur' }
                ],
                password: [
                    { required: true, message: 'Please enter password', trigger: 'blur'}
                ]
            },
            loading: false,
            form : {
                username : "",
                password : ""
            }
        }
    },
    computed: {
        loggingIn () {
            return this.$store.state.loggingIn
        },
        accessToken () {
            return this.$store.state.accessToken
        },
        refreshToken () {
            return this.$store.state.refreshToken
        }
    },
    methods:{
        ...mapMutations([
            'setFullPage'
        ]),
        ...mapActions([
           'login'
        ]),
        doLogin() {
            this.$refs['loginForm'].validate((valid) => {
                if (valid) {
                    //this.loading = true;

                    let credentials = {
                        username: this.form.username,
                        password: this.form.password
                    }

                    this.login(credentials)

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
    mounted() {
        this.setFullPage(true);
    }
}
</script>

<style lang="scss">
    /* 修复input 背景不协调 和光标变色 */
    /* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */
    $bg: #3e454b;
    $light_gray:#fff;
    $cursor: #fff;
    @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
        .login-container .el-input input {
            color: $cursor;
        }
    }
    /* reset element-ui css */
    .login-container {
        .el-input {
            display: inline-block;
            height: 47px;
            //width: 85%;
            input {
                background: transparent;
                border: 0px;
                -webkit-appearance: none;
                border-radius: 0px;
                //padding: 12px 5px 12px 15px;
                color: $light_gray;
                height: 47px;
                caret-color: $cursor;
                &:-webkit-autofill {
                    box-shadow: 0 0 0px 1000px $bg inset !important;
                    -webkit-text-fill-color: $cursor !important;
                }
            }
        }
        .el-form-item {
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            color: #454545;
        }
    }
</style>

<style lang="scss" scoped>
    $bg:#545c64;
    $dark_gray:#889aa4;
    $light_gray:#eee;
    .login-container {
        min-height: 100vh;
        width: 100%;
        background-color: $bg;
        overflow: hidden;
        .login-form {
            position: relative;
            width: 520px;
            max-width: 100%;
            padding: 160px 35px 0;
            margin: 0 auto;
            overflow: hidden;
        }
        .tips {
            font-size: 14px;
            color: #fff;
            margin-bottom: 10px;
            span {
                &:first-of-type {
                    margin-right: 16px;
                }
            }
        }
        .svg-container {
            padding: 6px 5px 6px 15px;
            color: $dark_gray;
            vertical-align: middle;
            width: 30px;
            display: inline-block;
        }
        .title-container {
            position: relative;
            .title {
                font-size: 26px;
                color: $light_gray;
                margin: 0px auto 40px auto;
                text-align: center;
                font-weight: bold;
            }
        }
        .show-pwd {
            position: absolute;
            right: 10px;
            top: 7px;
            font-size: 16px;
            color: $dark_gray;
            cursor: pointer;
            user-select: none;
        }
        .thirdparty-button {
            position: absolute;
            right: 0;
            bottom: 6px;
        }
        @media only screen and (max-width: 470px) {
            .thirdparty-button {
                display: none;
            }
        }
    }
</style>